import ClubcardToken from '@/lib/Clubcard/ClubcardToken';
import ClubcardTokenWithItems from '@/lib/Clubcard/ClubcardTokenWithItems';
import Hydrator from '@/lib/Hydration/Hydrator';
import logFactory from '@/libraries/DigiTickets/Logging/logFactory';
import PlaceholderItem from '@/lib/Items/PlaceholderItem';

export class ClubcardService {
    /**
     * @param {ApiClient} apiClient
     */
    constructor(
        apiClient
    ) {
        this.apiClient = apiClient;

        this.log = logFactory('ClubcardService');
    }

    /**
     * @param {string} tokenCode
     *
     * @return {Promise<ClubcardTokenWithItems|null>}
     */
    validateUKToken(tokenCode) {
        return this.apiClient
            .request(
                'POST',
                'clubcard/uk/tokens/validate',
                {
                    token: tokenCode,
                }
            )
            .then((response) => {
                this.log.debug('Clubcard Service response', response);
                const hydrator = new Hydrator();

                // Responses from the Clubcard Service proxy are inside a property called "response".
                let token = null;
                if (response.data.response.token) {
                    token = hydrator.hydrate(response.data.response.token, new ClubcardToken());
                }
                if (!token) {
                    return null;
                }

                let items = [];
                if (response.data.response.items) {
                    items = response.data.response.items.map((itemData) => {
                        return new PlaceholderItem({
                            ID: itemData.itemId,
                            itemType: itemData.itemType,
                            name: itemData.name,
                            branchIDs: itemData.branchIds,
                        });
                    });
                }

                const tokenWithItems = new ClubcardTokenWithItems(token, items);

                return tokenWithItems;
            });
    }
}
